import React from 'react';
export function Footer() {
  return <footer className="bg-warmBrown text-cream py-16" data-id="element-56">
      <div className="max-w-7xl mx-auto px-6" data-id="element-57">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-58">
          <div className="md:col-span-2" data-id="element-59">
            <div className="flex items-center gap-2 mb-6" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/mMVV4XoPmsr1QmNTgf4DWX/icon.png" alt="Pawchi logo" className="w-9 h-9 rounded-lg" data-id="element-61" />
              <span className="font-logo font-semibold text-2xl tracking-tight" data-id="element-62">
                Pawchi
              </span>
            </div>
            <p className="text-cream/60 max-w-sm leading-relaxed" data-id="element-63">
              Turning your real pet into a cute self-care companion. Build
              better routines, stay consistent, and take care of yourself —
              together.
            </p>
          </div>

          <div data-id="element-64">
            <h4 className="font-bold text-lg mb-6" data-id="element-65">Product</h4>
            <ul className="space-y-4" data-id="element-66">
              <li data-id="element-67">
                <a href="#features" className="text-cream/60 hover:text-peach transition-colors" data-id="element-68">
                  Features
                </a>
              </li>
              <li data-id="element-69">
                <a href="#how-it-works" className="text-cream/60 hover:text-peach transition-colors" data-id="element-70">
                  How it works
                </a>
              </li>
              <li data-id="element-71">
                <a href="#testimonials" className="text-cream/60 hover:text-peach transition-colors" data-id="element-72">
                  Stories
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="text-cream/60 hover:text-peach transition-colors" data-id="element-74">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-75">
            <h4 className="font-bold text-lg mb-6" data-id="element-76">Company</h4>
            <ul className="space-y-4" data-id="element-77">
              <li data-id="element-78">
                <a href="#" className="text-cream/60 hover:text-peach transition-colors" data-id="element-79">
                  About Us
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="text-cream/60 hover:text-peach transition-colors" data-id="element-81">
                  Careers
                </a>
              </li>
              <li data-id="element-82">
                <a href="/privacy-policy" className="text-cream/60 hover:text-peach transition-colors" data-id="element-83">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-84">
                <a href="/terms-of-use" className="text-cream/60 hover:text-peach transition-colors" data-id="element-85">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-86">
          <p className="text-cream/40 text-sm" data-id="element-87">
            © {new Date().getFullYear()} Pawchi App. All rights reserved.
          </p>
          <div className="flex gap-4 text-2xl" data-id="element-88">
            <a href="#" className="text-cream/40 hover:text-peach transition-colors" data-id="element-89">
              𝕏
            </a>
            <a href="#" className="text-cream/40 hover:text-peach transition-colors" data-id="element-90">
              📸
            </a>
            <a href="#" className="text-cream/40 hover:text-peach transition-colors" data-id="element-91">
              🎵
            </a>
          </div>
        </div>
      </div>
    </footer>;
}